import React from "react";
import ExpComponent from "../components/Experience/experience";

const Experience = () => {
  return (
    <div>
      <ExpComponent />
    </div>
  );
};

export default Experience;
